var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubtitleTranslationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 349,
    viewBox: "0 0 276 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3618 74.0319C69.3784 63.1773 78.4117 56.0708 89.6769 56.2228C104.703 56.4255 130.842 58.358 173.78 65.7308C216.718 73.1036 242.004 80.0011 256.237 84.8224C266.908 88.4369 273.053 98.1497 272.276 109.389C271.431 121.611 269.307 141.082 264.24 170.588C259.174 200.094 254.681 219.158 251.401 230.962C248.385 241.817 239.351 248.923 228.086 248.771C213.06 248.568 186.921 246.636 143.983 239.263C101.045 231.89 75.7588 224.993 61.5258 220.171C50.8551 216.557 44.7097 206.844 45.4868 195.605C46.3319 183.383 48.4561 163.912 53.5225 134.406C58.5889 104.9 63.0813 85.8363 66.3618 74.0319Z",
    fill: "#6491CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0597 103.732C90.1046 92.9011 99.0968 85.7506 110.347 85.8251C126.073 85.9292 153.978 87.8521 200.511 95.8421C247.043 103.832 273.991 111.328 288.851 116.476C299.482 120.158 305.574 129.899 304.832 141.125C303.971 154.123 301.712 175.304 296.105 207.961C290.497 240.618 285.562 261.339 282.037 273.88C278.991 284.711 269.999 291.861 258.749 291.787C243.023 291.682 215.118 289.76 168.586 281.77C122.053 273.78 95.1051 266.284 80.2449 261.136C69.6142 257.454 63.5223 247.713 64.2648 236.487C65.1245 223.488 67.3841 202.308 72.9915 169.651C78.599 136.994 83.5342 116.273 87.0597 103.732Z",
    fill: "#DCE2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.857 156.358C157.239 146.292 167.492 142.016 176.846 147.042C183.579 150.66 192.654 156.115 204.516 164.321C213.669 170.653 221.014 176.224 226.837 180.953C238.18 190.167 235.562 205.413 221.795 210.315C214.728 212.831 205.946 215.633 195.204 218.549C181.285 222.328 170.91 224.443 163.356 225.608C152.861 227.226 144.621 219.774 144.791 209.157C144.905 202.026 145.551 192.968 147.363 182.421C149.174 171.873 151.585 163.119 153.857 156.358Z",
    fill: "#6491CF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitleTranslationIcon);
export default __webpack_public_path__ + "static/media/subtitleTranslationIcon.89de014bd77d643be1b3fd14314d7ecc.svg";
export { ForwardRef as ReactComponent };